module.exports = __webpack_public_path__ + "img/chat_ch.a29cfd06.png";